<template lang="html">
  <b-card>
    <h5>Nomes</h5>
    <b-form-group v-if="idCheck"
      label="Nome (SERPRO)"
      label-for="nomeecommerce"
      :label-cols="3"
      :horizontal="true">
      <b-form-input plaintext id="nomeecommerce" type="text" :value="idCheck.reason.name.status + ' (' + idCheck.reason.name.reason + ')'"></b-form-input>
      <b-progress :value="idCheck.reason.name.similarity * 100" variant="primary" striped class="mb-2"></b-progress>
    </b-form-group>
    <b-form-group
      label="Nome (Checkout)"
      label-for="nomeecommerce"
      :label-cols="3"
      :horizontal="true">
      <b-form-input plaintext id="nomeecommerce" type="text" :value="transaction.buyerName"></b-form-input>
    </b-form-group>
    <b-form-group
      label="Nome (E-commerce)"
      label-for="nomeecommerce"
      :label-cols="3"
      :horizontal="true">
      <b-form-input plaintext id="nomeecommerce" type="text" :value="user.name"></b-form-input>
    </b-form-group>
    <b-form-group v-if="backCheck"
      label="Nome (SPC)"
      label-for="nomespc"
      :label-cols="3"
      :horizontal="true">
      <b-form-input plaintext id="nomespc" type="text" :value="backCheck.reason.spc_check ? backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['nome'] : (backCheck.reason.grade.reason.debug['spc-serasa'] ? backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['nome'] : '')"></b-form-input>
    </b-form-group>
    <b-form-group
      :label="'Nome (' + facebook.network + ')'"
      label-for="nomefacebook"
      :label-cols="3"
      :horizontal="true">
      <b-form-input plaintext id="nomefacebook" type="text" :value="facebook.name"></b-form-input>
    </b-form-group>
    <b-row v-for="phone in phones" v-bind:key="phone.id">
      <b-col cols="12">
        <b-form-group
          v-if="faceCheck && faceCheck.status === 'OK' && phone.defaultPhoneNumber"
          label="Confirmar nome"
          label-for="nomeWhatsapp"
          :label-cols="3"
          :horizontal="true">
          <button-component v-if="phone.defaultPhoneNumber" :href="'https://api.whatsapp.com/send?phone=55' + phone.phoneNumber + '&text=' + text" target="_blank" class="btn btn-outline-success"><i class="micon-whatsapp"></i>Confirmar via Whats</button-component>
        </b-form-group>
      </b-col>
    </b-row>
    <hr>
    <phone-manager-component :user="user" :tx="tx" :reference="reference"></phone-manager-component>
    <hr>
    <email-manager-component :user="user" :tx="tx" :reference="reference"></email-manager-component>
    <hr>
    <h5>Endereço de Entrega</h5>
    <b-form-group label="Rua, número"
                  label-for="enderecoRua"
                  :label-cols="3"
                  :horizontal="true">
      <b-form-input plaintext id="enderecoRua" type="text" :value="shipping.address.street + ', ' + shipping.address.number"></b-form-input>
    </b-form-group>
    <b-form-group label="Complemento/Bairro"
                  label-for="enderecoComplemento"
                  :label-cols="3"
                  :horizontal="true">
      <b-form-input plaintext id="enderecoComplemento" type="text" :value="shipping.address.complement + ' - ' + shipping.address.district"></b-form-input>
    </b-form-group>
    <b-form-group label="CEP/Cidade/UF"
                  label-for="enderecoCidade"
                  :label-cols="3"
                  :horizontal="true">
      <b-form-input plaintext id="enderecoCidade" type="text" :value="shipping.address.zip + ' - ' + shipping.address.city + ' (' + shipping.address.state + ')'"></b-form-input>
    </b-form-group>
    <div v-if="backCheck && ((backCheck.reason.spc_check && backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']) || (backCheck.reason.grade.reason.debug['spc-serasa'] && backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']))">
      <h5>Endereço (SPC)</h5>
      <b-form-group
                    label="Rua, número (SPC)"
                    label-for="enderecoSpcRua"
                    :label-cols="3"
                    :horizontal="true">
        <b-form-input plaintext id="enderecoSpcRua" type="text" :value="backCheck.reason.spc_check ? backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['logradouro'] + ', ' + backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['numero'] : (backCheck.reason.grade.reason.debug['spc-serasa'] ? backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['logradouro'] + ', ' + backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['numero'] : '')"></b-form-input>
      </b-form-group>
      <b-form-group label="Complemento/Bairro (SPC)"
                    label-for="enderecoSpcComplemento"
                    :label-cols="3"
                    :horizontal="true">
        <b-form-input plaintext id="enderecoSpcComplemento" type="text" :value="backCheck.reason.spc_check ? backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['complemento'] + ' - ' + backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['bairro'] : (backCheck.reason.grade.reason.debug['spc-serasa'] ? backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['complemento'] + ' - ' + backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['bairro'] : '')"></b-form-input>
      </b-form-group>
      <b-form-group label="CEP/Cidade/UF (SPC)"
                    label-for="enderecoSpcCidade"
                    :label-cols="3"
                    :horizontal="true">
        <b-form-input plaintext id="enderecoSpcCidade" type="text" :value="backCheck.reason.spc_check ? backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['cep'] + ' - ' + backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['cidade']['nome'] + ' - ' + backCheck.reason.spc_check.debug.consumidor['consumidor-pessoa-fisica']['endereco']['cidade']['estado']['sigla-uf'] : (backCheck.reason.grade.reason.debug['spc-serasa'] ? backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['cep'] + ' - ' + backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['cidade']['nome'] + ' - ' +  backCheck.reason.grade.reason.debug['spc-serasa']['consumidor']['consumidor-pessoa-fisica']['endereco']['cidade']['estado']['sigla-uf'] : '')"></b-form-input>
      </b-form-group>
    </div>
  </b-card>
</template>
<script>
import Button from '../../button/Button.vue'
import Input from '../../form/Input.vue'
import ContactPhoneManager from '../contacts/ContactPhoneManager.vue'
import ContactEmailManager from '../contacts/ContactEmailManager.vue'
import { extractFirstName } from '../../../../utils/extractFirstName'

export default {
  components: {
    'button-component': Button,
    'input-component': Input,
    'phone-manager-component': ContactPhoneManager,
    'email-manager-component': ContactEmailManager
  },
  data () {
    return {
      text: `Olá ${this.extractFirstName(this.user.name)}, tudo bem? Aqui é do Boleto Parcelado da BoletoFlex. Nós recebemos seu pedido ${this.reference} na ${this.tx.sellerName} e está tudo certo. Você pode apenas nos confirmar seu nome completo para liberarmos o pedido?`,
      phones: []
      // newPhone: null
    }
  },
  props: ['user', 'backCheck', 'idCheck', 'faceCheck', 'validation', 'facebook', 'transaction', 'shipping', 'reference', 'tx'],
  methods: {
    loadPhones () {
      this.$http.get('api/validations/' + this.$route.params.txid + '/phones')
        .then(function (res) {
          this.phones = res.data.list
          this.phones = this.phones.sort(function (a, b) {
            return (a.defaultPhoneNumber === b.defaultPhoneNumber) ? 0 : a.defaultPhoneNumber ? -1 : 1
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    },
    extractFirstName
  },
  mounted () {
    this.$root.$on('loadphone', () => {
      this.loadPhones()
    })
    this.loadPhones()
  },
  watch: {
    'backCheck' () {
    },
    '$route.params.txid' () {
      this.loadPhones()
    }
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/partial/cards/verification/NameCheck.vue